<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">充值</span>
    </div>
    <div class="search-one">
      <p class="" style="margin-bottom:0 ;">当前账户余额
        <span class="pl20">$ {{current_amount}}</span>
      </p>
    </div>
    <div class="mt20 pl100">
      充值金额
      <span class="ml20">$</span>
      <InputNumber v-model="amount" class="w200" :min="0.01"></InputNumber>
    </div>
    <div class="mt20 pl100">
      <RadioGroup v-model="pay_type">
              <Radio label="alipay" border>支付宝</Radio>
              <Radio label="wechatpay" border>微信支付</Radio>
          </RadioGroup>
    </div>
    <div class="mt50 ml100">
      <button class="ivu-btn ivu-btn-primary ml100" @click="recharge">去充值</button>
    </div>
    <p class="mt50 f16">充值流水：</p>
    <Table class="mt20" border :columns="table_data.columns" :data="table_data.data">
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        warehouse_id: '',
        amount: 100, //充值金额
        current_amount:0,//账户余额
        pay_type:'alipay',
        table_data: { //列表数据
          columns: [],
          data: []
        },
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      recharge() {
        if (!this.amount) {
          this.$Message.info('请输入充值金额')
          return false
        }
        if (this.amount <= 0) {
          this.$Message.info('请输入大于0的金额')
          return false
        }
        let obj = {
          amount: this.amount,
          warehouse_id: this.warehouse_id,
          pay_type: this.pay_type
        }
        this.$axios.post('ClientBill/fee/charge', this.$qs.stringify(obj)).then(res => {
          if (res.success) {
            window.location.href = res.data;
          } else {
            this.$Message.info(res.msg);
          }
        })

      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/ClientBill/fee/charge", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '充值单号',
          key: 'client_charge_no',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '创建日期',
          key: 'create_date',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '状态',
          key: 'status',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status; //0-创建， 1-到账
            if (status == 0) {
              return h("span", "创建");
            } else if (status == 1) {
              return h("span", "到账");
            }
          }
        }, {
          title: '类型',
          key: 'charge_type',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            let charge_type = params.row.charge_type; //0-手动充值， 1-在线充值
            if (charge_type == 0) {
              return h("span", "手动充值");
            } else if (charge_type == 1) {
              return h("span", "在线充值");
            }
          }
        }, {
          title: '金额',
          key: 'amount',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
             return h("span", "$"+ params.row.amount);
          }
        }, {
          title: '交易流水号',
          key: 'third_bill_no',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '到账日期',
          key: 'charge_date',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '备注',
          key: 'remark',
          tooltip: true,
          minWidth: 200,
        }];
        return arr;
      },
      getAmount() { //查询账户余额
        this.$axios.get('/dashboard/client/account').then(res => {
          if (res.success && res.data) {
            this.current_amount = res.data.current_amount || 0
          }
        })
      },
    },
    created() {
      this.init();
      this.getAmount()
      this.warehouse_id = localStorage.getItem('warehouse_id')
      if (this.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
    }
  }
</script>

<style scoped>
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/recharge.vue